module.exports = __webpack_public_path__ + "img/caneca_verde.65694750.png";